export const GET_FACTS = 'GET_FACTS';
export const SET_FACTS = 'SET_FACTS';
export const ADD_FACT = 'ADD_FACT';
export const UPDATE_FACT = 'UPDATE_FACT';
export const DELETE_FACT = 'DELETE_FACT';
